export const checkboxIconStyle = () => ({
	checkboxIcon: {
		width: 24,
		height: 24,
		boxSizing: 'border-box',
		borderRadius: 2,
		backgroundColor: '#FFFFFF',
		border: '2px solid #D4D6D7',
	},
	checkboxIconChecked: {
		border: '2px solid #1c1e22',
		backgroundColor: '#1c1e22',
		backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23ffffff\' stroke-width=\'3\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cpolyline points=\'4 12 9 17 20 6\'/%3E%3C/svg%3E")',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center',
		backgroundSize: '18px 18px',
	},
});